import script from "./Device.vue?vue&type=script&setup=true&lang=js"
export * from "./Device.vue?vue&type=script&setup=true&lang=js"

import "./Device.vue?vue&type=style&index=0&id=03e0b9a0&lang=less&scoped=true"

import exportComponent from "D:\\yisa_project\\访客预约系统\\vrs_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03e0b9a0"]])

export default __exports__